<!--
- 领取（手机端）
- author: wy
- greatTime: 2019-11-06
-->
<template lang="html">
  <div class="pay-status-container" :style="{'height': window_height+'px'}">
    <img :src="$store.state.static_img_url + 'pic/buyvip/yes.png'">
    <p class="one">开通成功</p>
    <p class="two">您已成功开通VIP体验包</p>
    <p class="three">5分钟内生效<br>请在电脑端体验VIP服务<br>动脉网VIP入口：<span>{{dist}}</span></p>
    <!-- <p class="button" @click="go">返回首页</p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      dist: this.$store.state.req_url
    }
  },
  computed: {
    window_height() {
      return document.documentElement.clientHeight
    }
  },
  // methods: {
  //   go() {
  //     this.$router.replace({name: 'VipExperience', query: { p: this.$route.query.p, sign: this.$route.query.sign}})
  //   }
  // }
}
</script>

<style lang="stylus" scoped>
.pay-status-container
  background-color: #F8F8F8;
  text-align: center;
  color: #333333;
  img
    margin-top: 1.6rem;
  .one
    font-size: .48rem;
    font-weight: bold;
    margin-top: 1.1rem;
  .two
    font-size: .28rem;
    margin-top: .3rem;
  .three
    width: 100%;
    text-align: center;
    line-height: .42rem
    color: #666
    margin-top: .6rem
    span
      color: rgba(250, 122, 80, 1)
  .button
    display: block;
    position: fixed;
    bottom: .32rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6rem;
    height: .9rem;
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    line-height: .9rem;
    border-radius: .1rem;
    background: rgba(250, 122, 80, 1)
    background: linear-gradient(90deg,rgba(255,183,94,1) 0%,rgba(244,107,69,1) 100%);
    box-shadow: 0px 5px 14px 1px rgba(121,133,143,0.4);
</style>
